"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const pda_1 = require("../utils/pda");
const common_1 = require("../contract/common");
const pda_2 = require("../utils/pda");
const programIds_1 = require("../constants/programIds");
const spl_token_1 = require("@solana/spl-token");
const common_2 = require("../constants/common");
const { generateRemainingAccountsForCreateClass, generateRemainingAccountsGivenPermissivenessToUse, } = common_1.ContractCommon;
const PLAYER_CLASS_DATA_ARGS_CONVERT_TO_BNS = [
    "playerClassData.settings.stakingWarmUpDuration",
    "playerClassData.settings.stakingCooldownDuration",
    "playerClassData.config.basicStats.[].statType.integer.min",
    "playerClassData.config.basicStats.[].statType.integer.max",
    "playerClassData.config.basicStats.[].statType.integer.starting",
    "playerClassData.config.basicStats.[].statType.integer.stakingAmountScaler",
    "playerClassData.config.basicStats.[].statType.integer.stakingDurationScaler",
    "playerClassData.config.basicStats.[].statType.bool.stakingFlip",
    "playerClassData.config.bodyParts.[].totalItemSpots",
    "playerClassData.config.equipValidation.code",
    "playerClassData.config.addToPackValidation.code",
];
const PLAYER_DATA_ARGS_CONVERT_TO_BNS = [
    "newData.basicStats.[].state.integer.base",
    "newData.basicStats.[].state.integer.withTemporaryChanges",
    "newData.basicStats.[].state.integer.temporaryNumerator",
    "newData.basicStats.[].state.integer.temporaryDivisor",
    "newData.basicStats.[].state.integer.finalized",
];
const PLAYER_CLASS_DATA_ARGS_CONVERT_TO_PUBKEYS = [
    "playerClassData.config.equipValidation.key",
    "playerClassData.config.addToPackValidation.key",
];
class Instruction extends sol_kit_1.Instruction {
    constructor(args) {
        super(args);
    }
    async createPlayerClass(args, accounts, _additionalArgs = {}) {
        const remainingAccounts = await generateRemainingAccountsForCreateClass({
            permissivenessToUse: args.updatePermissivenessToUse,
            tokenMint: accounts.playerMint,
            parentMint: accounts.parentMint,
            parent: accounts.parent,
            parentOfParentClassMint: accounts.parentOfParentClassMint,
            parentOfParentClassIndex: args.parentOfParentClassIndex,
            parentOfParentClass: args.parentOfParentClassIndex && accounts.parentOfParentClassMint
                ? (await pda_2.getPlayerPDA(accounts.parentOfParentClassMint, args.parentOfParentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentUpdateAuthority: accounts.parentUpdateAuthority,
            program: this.program,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "classIndex",
            "parentOfParentClassIndex",
            "parentClassIndex",
            "space",
            ...PLAYER_CLASS_DATA_ARGS_CONVERT_TO_BNS,
        ]);
        sol_kit_1.InstructionUtils.convertStringsToPublicKeys(args, PLAYER_CLASS_DATA_ARGS_CONVERT_TO_PUBKEYS);
        const [playerClassKey, _] = await pda_2.getPlayerPDA(accounts.playerMint, args.classIndex);
        return {
            instructions: [
                await this.program.client.methods
                    .createPlayerClass(args)
                    .accounts({
                    playerClass: playerClassKey,
                    playerMint: accounts.playerMint,
                    metadata: await pda_1.getMetadata(accounts.playerMint),
                    edition: await pda_1.getEdition(accounts.playerMint),
                    parent: accounts.parent || playerClassKey,
                    payer: this.program.client.provider.wallet
                        .publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async updatePlayerClass(args, accounts, additionalArgs = { permissionless: true }) {
        const remainingAccounts = additionalArgs.permissionless
            ? [{ pubkey: accounts.parent, isWritable: false, isSigner: false }]
            : await generateRemainingAccountsGivenPermissivenessToUse({
                permissivenessToUse: args.updatePermissivenessToUse,
                tokenMint: accounts.playerMint,
                parentMint: accounts.parentMint,
                parentIndex: args.parentClassIndex,
                parent: accounts.parent,
                metadataUpdateAuthority: accounts.metadataUpdateAuthority,
                parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
                program: this.program.client,
            });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "classIndex",
            "parentClassIndex",
            ...PLAYER_CLASS_DATA_ARGS_CONVERT_TO_BNS,
        ]);
        sol_kit_1.InstructionUtils.convertStringsToPublicKeys(args, PLAYER_CLASS_DATA_ARGS_CONVERT_TO_PUBKEYS);
        const playerClassKey = (await pda_2.getPlayerPDA(accounts.playerMint, args.classIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .updatePlayerClass(args)
                    .accounts({
                    playerClass: playerClassKey,
                    parent: accounts.parent || anchor_1.web3.SystemProgram.programId,
                    playerMint: accounts.playerMint,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async drainPlayerClass(args, accounts, _additionalArgs = {}) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.updatePermissivenessToUse,
            tokenMint: accounts.playerMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "classIndex",
            "parentClassIndex",
        ]);
        const playerClassKey = (await pda_2.getPlayerPDA(accounts.playerMint, args.classIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .drainPlayerClass(args)
                    .accounts({
                    playerClass: playerClassKey,
                    parentClass: accounts.parent || accounts.parentMint
                        ? (await pda_2.getPlayerPDA(accounts.parentMint, args.parentClassIndex))[0]
                        : playerClassKey,
                    receiver: this.program.client.provider.wallet
                        .publicKey,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async buildPlayer(args, accounts, additionalArgs) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.buildPermissivenessToUse,
            tokenMint: args.playerClassMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parentMint && !!args.parentClassIndex
                ? (await pda_2.getPlayerPDA(accounts.parentMint, args.parentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "classIndex",
            "parentClassIndex",
            "newPlayerIndex",
            "space",
        ]);
        const [playerClassKey, _] = await pda_2.getPlayerPDA(args.playerClassMint, args.classIndex);
        const [newPlayer, __] = await pda_2.getPlayerPDA(accounts.newPlayerMint, args.newPlayerIndex);
        const transferAuthority = accounts.rainTransferAuthority || web3_js_1.Keypair.generate();
        const myRainAccount = accounts.rainToken ||
            (await pda_1.getAtaForMint(common_2.RAIN_TOKEN_MINT, this.program.client.provider.wallet.publicKey))[0];
        const instructions = [];
        const signers = [];
        if (additionalArgs.rainAmount.toNumber() > 0) {
            instructions.push(spl_token_1.Token.createApproveInstruction(programIds_1.TOKEN_PROGRAM_ID, myRainAccount, transferAuthority.publicKey, this.program.client.provider.wallet.publicKey, [], additionalArgs.rainAmount.toNumber()));
            signers.push(transferAuthority);
        }
        instructions.push(await this.program.client.methods
            .buildPlayer(args)
            .accounts({
            playerClass: playerClassKey,
            newPlayer,
            newPlayerMint: accounts.newPlayerMint,
            newPlayerMetadata: await pda_1.getMetadata(accounts.newPlayerMint),
            newPlayerEdition: await pda_1.getEdition(accounts.newPlayerMint),
            newPlayerToken: accounts.newPlayerToken,
            newPlayerTokenHolder: accounts.newPlayerTokenHolder,
            rainTokenTransferAuthority: transferAuthority.publicKey,
            rainToken: myRainAccount,
            rainTokenMint: common_2.RAIN_TOKEN_MINT,
            rainTokenProgramAccount: await pda_2.getPlayerRainVault(),
            payer: this.program.client.provider.wallet
                .publicKey,
            systemProgram: web3_js_1.SystemProgram.programId,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
        })
            .remainingAccounts(remainingAccounts)
            .instruction());
        if (additionalArgs.rainAmount.toNumber() > 0) {
            instructions.push(spl_token_1.Token.createRevokeInstruction(programIds_1.TOKEN_PROGRAM_ID, myRainAccount, this.program.client.provider.wallet.publicKey, []));
        }
        return {
            instructions,
            signers,
        };
    }
    async updatePlayer(args, accounts, additionalArgs = { permissionless: true }) {
        const parent = (await pda_2.getPlayerPDA(args.playerClassMint, args.classIndex))[0];
        const remainingAccounts = additionalArgs.permissionless
            ? [{ pubkey: parent, isWritable: false, isSigner: false }]
            : await generateRemainingAccountsGivenPermissivenessToUse({
                permissivenessToUse: args.updatePermissivenessToUse,
                tokenMint: args.playerMint,
                parentMint: args.playerClassMint,
                parentIndex: args.classIndex,
                parent,
                metadataUpdateAuthority: accounts.metadataUpdateAuthority,
                parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
                program: this.program.client,
            });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "classIndex",
            "index",
            ...PLAYER_DATA_ARGS_CONVERT_TO_BNS,
        ]);
        const playerKey = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .updatePlayer(args)
                    .accounts({
                    player: playerKey,
                    playerClass: parent,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async drainPlayer(args, accounts, _additionalArgs = {}) {
        const parent = (await pda_2.getPlayerPDA(args.playerClassMint, args.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.updatePermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: args.playerClassMint,
            parentIndex: args.classIndex,
            parent: parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, ["classIndex", "index"]);
        const player = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const myRainAccount = accounts.rainToken ||
            (await pda_1.getAtaForMint(common_2.RAIN_TOKEN_MINT, this.program.client.provider.wallet.publicKey))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .drainPlayer(args)
                    .accounts({
                    playerClass: parent,
                    player,
                    rainToken: myRainAccount,
                    rainTokenProgramAccount: await pda_2.getPlayerRainVault(),
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                    receiver: this.program.client.provider.wallet
                        .publicKey,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async toggleEquipItem(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.equipItemPermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "itemIndex",
            "index",
            "amount",
            "bodyPartIndex",
            "itemUsageIndex",
        ]);
        const player = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const item = (await pda_1.getItemPDA(args.itemMint, args.itemIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .toggleEquipItem(args)
                    .accounts({
                    playerClass: parent,
                    player,
                    item,
                    itemClass: (await pda_1.getItemPDA(args.itemClassMint, additionalArgs.itemClassIndex))[0],
                    playerItemAccount: (await pda_1.getPlayerItemAccount({ item, player }))[0],
                    validationProgram: accounts.validationProgram || web3_js_1.SystemProgram.programId,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async resetPlayerStats(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.equipItemPermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, ["index"]);
        const player = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .resetPlayerStats(args)
                    .accounts({
                    playerClass: parent,
                    player,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async useItem(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.useItemPermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "itemIndex",
            "itemClassIndex",
            "amount",
            "itemUsageIndex",
            "index",
        ]);
        const playerKey = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const item = (await pda_1.getItemPDA(args.itemMint, args.itemIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .useItem(args)
                    .accounts({
                    player: playerKey,
                    playerClass: parent,
                    item,
                    itemClass: (await pda_1.getItemPDA(args.itemClassMint, args.itemClassIndex))[0],
                    playerItemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                    itemActivationMarker: (await pda_1.getItemActivationMarker({
                        itemMint: args.itemMint,
                        itemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                        index: args.itemIndex,
                        usageIndex: new anchor_1.BN(args.itemUsageIndex),
                        amount: args.amount,
                    }))[0],
                    payer: this.program.client.provider.wallet
                        .publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                    itemProgram: programIds_1.ITEM_ID,
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                    rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                    validationProgram: accounts.validationProgram || web3_js_1.SystemProgram.programId,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async updateValidForUseIfWarmupPassedOnItem(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.usagePermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "itemIndex",
            "itemClassIndex",
            "amount",
            "itemUsageIndex",
            "index",
        ]);
        const playerKey = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const item = (await pda_1.getItemPDA(args.itemMint, args.itemIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .updateValidForUseIfWarmupPassedOnItem(args)
                    .accounts({
                    player: playerKey,
                    playerClass: parent,
                    item,
                    playerItemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                    itemClass: (await pda_1.getItemPDA(args.itemClassMint, args.itemClassIndex))[0],
                    itemMint: args.itemMint,
                    itemActivationMarker: (await pda_1.getItemActivationMarker({
                        itemMint: args.itemMint,
                        itemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                        index: args.itemIndex,
                        usageIndex: new anchor_1.BN(args.itemUsageIndex),
                        amount: args.amount,
                    }))[0],
                    itemProgram: programIds_1.ITEM_ID,
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async addItemEffect(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.useItemPermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "itemIndex",
            "itemClassIndex",
            "index",
            "itemUsageIndex",
            "space",
        ]);
        const playerKey = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const item = (await pda_1.getItemPDA(accounts.itemMint, args.itemIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .addItemEffect(args)
                    .accounts({
                    player: playerKey,
                    playerClass: parent,
                    playerItemActivationMarker: (await pda_1.getPlayerItemActivationMarker({
                        item,
                        player: playerKey,
                        amount: additionalArgs.amount,
                        itemUsageIndex: new anchor_1.BN(args.itemUsageIndex),
                    }))[0],
                    itemMint: accounts.itemMint,
                    itemActivationMarker: (await pda_1.getItemActivationMarker({
                        itemMint: accounts.itemMint,
                        itemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                        index: args.itemIndex,
                        usageIndex: new anchor_1.BN(args.itemUsageIndex),
                        amount: additionalArgs.amount,
                    }))[0],
                    item,
                    itemClass: (await pda_1.getItemPDA(args.itemClassMint, args.itemClassIndex))[0],
                    playerItemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                    payer: this.program.client.provider.wallet
                        .publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                    itemProgram: programIds_1.ITEM_ID,
                    callbackProgram: accounts.callbackProgram || web3_js_1.SystemProgram.programId,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
    async subtractItemEffect(_args = {}, accounts, additionalArgs) {
        return {
            instructions: [
                await this.program.client.methods
                    .subtractItemEffect()
                    .accounts({
                    player: accounts.player,
                    playerClass: accounts.playerClass,
                    playerItemActivationMarker: (await pda_1.getPlayerItemActivationMarker({
                        item: accounts.item,
                        player: accounts.player,
                        amount: additionalArgs.amount,
                        itemUsageIndex: new anchor_1.BN(additionalArgs.itemUsageIndex),
                    }))[0],
                    item: accounts.item,
                    receiver: accounts.receiver ||
                        this.program.client.provider.wallet.publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
    async addItem(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.addItemPermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "itemIndex",
            "index",
            "amount",
        ]);
        const playerKey = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const signers = [];
        const itemTransferAuthority = accounts.itemTransferAuthority || anchor_1.web3.Keypair.generate();
        signers.push(itemTransferAuthority);
        const item = (await pda_1.getItemPDA(accounts.itemMint, args.itemIndex))[0];
        return {
            instructions: [
                spl_token_1.Token.createApproveInstruction(programIds_1.TOKEN_PROGRAM_ID, accounts.itemAccount, itemTransferAuthority.publicKey, this.program.client.provider.wallet.publicKey, [], args.amount.toNumber()),
                await this.program.client.methods
                    .addItem(args)
                    .accounts({
                    player: playerKey,
                    playerClass: parent,
                    item,
                    itemClass: (await pda_1.getItemPDA(additionalArgs.itemClassMint, additionalArgs.itemClassIndex))[0],
                    itemMint: accounts.itemMint,
                    itemAccount: accounts.itemAccount,
                    itemTransferAuthority: itemTransferAuthority.publicKey,
                    playerItemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                    payer: accounts.payer ||
                        this.program.client.provider.wallet.publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                    validationProgram: accounts.validationProgram || web3_js_1.SystemProgram.programId,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
                ...(additionalArgs.totalItemsAvailable.toNumber() >
                    args.amount.toNumber()
                    ? [
                        spl_token_1.Token.createRevokeInstruction(programIds_1.TOKEN_PROGRAM_ID, accounts.itemAccount, this.program.client.provider.wallet
                            .publicKey, []),
                    ]
                    : []),
            ],
            signers,
        };
    }
    async removeItem(args, accounts, additionalArgs) {
        const parent = (await pda_2.getPlayerPDA(additionalArgs.playerClassMint, additionalArgs.classIndex))[0];
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.removeItemPermissivenessToUse,
            tokenMint: args.playerMint,
            parentMint: additionalArgs.playerClassMint,
            parentIndex: additionalArgs.classIndex,
            parent,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "itemIndex",
            "index",
            "amount",
        ]);
        const playerKey = (await pda_2.getPlayerPDA(args.playerMint, args.index))[0];
        const item = (await pda_1.getItemPDA(accounts.itemMint, args.itemIndex))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .removeItem(args)
                    .accounts({
                    player: playerKey,
                    playerClass: parent,
                    item,
                    itemClass: (await pda_1.getItemPDA(additionalArgs.itemClassMint, additionalArgs.itemClassIndex))[0],
                    itemMint: accounts.itemMint,
                    itemAccount: accounts.itemAccount,
                    itemAccountOwner: accounts.itemAccountOwner ||
                        this.program.client.provider.wallet.publicKey,
                    playerItemAccount: (await pda_1.getPlayerItemAccount({ item, player: playerKey }))[0],
                    payer: accounts.payer ||
                        this.program.client.provider.wallet.publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                    associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                    validationProgram: accounts.validationProgram || web3_js_1.SystemProgram.programId,
                })
                    .remainingAccounts(remainingAccounts)
                    .instruction(),
            ],
            signers: [],
        };
    }
}
exports.Instruction = Instruction;
